var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe_div"},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.url,"width":"100%","height":"90%"}}),_c('div',{staticClass:"type",on:{"click":_vm.closeiframe}},[_vm._v("返回")])])}
var staticRenderFns = []

export { render, staticRenderFns }